'use client';

import { Product } from '@/lib/shopify/types';
import { ProductCard } from '@/components/product/product-card';

export function FeaturedProductCard({ product }: { product: Product }) {
  return <ProductCard product={product} />;
}
